import { create } from "zustand";
import { devtools, subscribeWithSelector } from "zustand/middleware";
import { DEVTOOLS_ENABLED } from "../../consts";

interface HeaderState {
  /** The shared search-bar query, consumed by every list/search page. */
  query: string;
  setQuery: (query: string) => void;
}

// Replaces the `query` preact signal.
//
// `create` comes from "zustand" directly, NOT feat/appState/resetState: that wrapper
// registers stores for `resetAllStores()` on logout, and the signal was never reset.
// The pages that want a clean search box already clear it explicitly on mount
// (list-page, baseListPage), so adding a logout reset would be a new behaviour.
export const useHeaderStore = create<HeaderState>()(
  subscribeWithSelector(
    devtools(
      (set) => ({
        query: "",
        setQuery: (query) => set({ query }, false, "setQuery"),
      }),
      { enabled: DEVTOOLS_ENABLED, name: "header" },
    ),
  ),
);

export const useQuery = () => useHeaderStore((s) => s.query);
